module.exports = __webpack_public_path__ + "static/media/london_25-sits_oppet_avslut_tyg_mito_detalj_2023_6.ac47fe04.jpg";